{
  " (you)": " (you)",
  " ({{unreadCount}} unread)": " ({{unreadCount}} unread)",
  "#": "#",
  "#a-channel": "#a-channel",
  "#a-channel or @someone": "#a-channel or @someone",
  ", {{membersLength}} others": ", {{membersLength}} others",
  "<0>{formatUserNames(names)} <2>reacted with</2></0>": "<0>{formatUserNames(names)} <2>reacted with</2></0>",
  "@someone": "@someone",
  "About": "About",
  "Accepted file formats: .jpeg, .jpg and .png": "Accepted file formats: .jpeg, .jpg and .png",
  "Add": "Add",
  "Add Member": "Add Member",
  "Add Members": "Add Members",
  "Add Reaction": "Add Reaction",
  "Add channel": "Add channel",
  "Add description": "Add description",
  "Add direct message": "Add direct message",
  "Add topic": "Add topic",
  "All Activity:": "All Activity:",
  "All Chats": "All Chats",
  "Apply": "Apply",
  "Archive Channel for everyone": "Archive Channel for everyone",
  "Archive Conversation": "Archive Conversation",
  "Are you sure you want to archive this conversation?": "Are you sure you want to archive this conversation?",
  "Are you sure you want to delete this conversation? You will not be able to recover this conversation after deleting.": "Are you sure you want to delete this conversation? You will not be able to recover this conversation after deleting.",
  "Are you sure you want to delete this message? This cannot be undone.": "Are you sure you want to delete this message? This cannot be undone.",
  "Are you sure you want to hide this conversation?": "Are you sure you want to hide this conversation?",
  "Are you sure you want to leave this conversation?": "Are you sure you want to leave this conversation?",
  "Are you sure you want to remove this member?": "Are you sure you want to remove this member?",
  "Back": "Back",
  "Block all notification indicators unless I am specifically @mentioned, then display a numbered red dot.": "Block all notification indicators unless I am specifically @mentioned, then display a numbered red dot.",
  "Bold all channel and direct message names when someone posts a new comment, and use a numbered red dot only when I am specifically @mentioned.": "Bold all channel and direct message names when someone posts a new comment, and use a numbered red dot only when I am specifically @mentioned.",
  "Cancel": "Cancel",
  "Channel Name": "Channel Name",
  "Channel name already exists": "Channel name already exists",
  "Channels": "Channels",
  "Channels are where conversations happen around a topic, choose a name that is easy to understand and find.": "Channels are where conversations happen around a topic, choose a name that is easy to understand and find.",
  "Channels are where conversations happen around a topic. Use a name that is easy to find and understand.": "Channels are where conversations happen around a topic. Use a name that is easy to find and understand.",
  "Clear": "Clear",
  "Clear Status": "Clear Status",
  "Close": "Close",
  "Commuting": "Commuting",
  "Continue receiving notifications even if the team chat panel is open and active.": "Continue receiving notifications even if the team chat panel is open and active.",
  "Conversation hidden successfully.": "Conversation hidden successfully.",
  "Create": "Create",
  "Create a channel": "Create a channel",
  "Created by:": "Created by:",
  "Creating a new conversation": "Creating a new conversation",
  "Creating new conversation": "Creating new conversation",
  "Default": "Default",
  "Define the focus of your discussion with {{name}}.": "Define the focus of your discussion with {{name}}.",
  "Delete Channel": "Delete Channel",
  "Delete Conversation": "Delete Conversation",
  "Delete Message": "Delete Message",
  "Delete Message...": "Delete Message...",
  "Description:": "Description:",
  "Direct Messages": "Direct Messages",
  "Don’t show this message again": "Don’t show this message again",
  "Drive me crazy: use numbered red dots for every new comment and @mention.": "Drive me crazy: use numbered red dots for every new comment and @mention.",
  "Drop image here": "Drop image here",
  "Edit": "Edit",
  "Edit Message": "Edit Message",
  "Error loading replies": "Error loading replies",
  "Failed to archive conversation": "Failed to archive conversation",
  "Failed to delete message": "Failed to delete message",
  "Failed to send message": "Failed to send message",
  "Failed to unarchive conversation": "Failed to unarchive conversation",
  "For you": "For you",
  "From: 1 member": "From: 1 member",
  "From: @member": "From: @member",
  "From: @{{label}}": "From: @{{label}}",
  "From: {{count}} members_one": "From: {{count}} members",
  "From: {{count}} members_other": "From: {{count}} members",
  "Getting latest messages": "Getting latest messages",
  "Has": "Has",
  "Has: {{label}}": "Has: {{label}}",
  "Hide Conversation": "Hide Conversation",
  "Hide conversation in Channels section": "Hide conversation in Channels section",
  "Hide conversation in Direct Message section": "Hide conversation in Direct Message section",
  "Highlight:": "Highlight:",
  "If someone replies in a thread related to you, you'll see their messages here!": "If someone replies in a thread related to you, you'll see their messages here!",
  "Image": "Image",
  "In Direct Message ": "In Direct Message ",
  "In a meeting": "In a meeting",
  "In: ": "In: ",
  "In: All Chats": "In: All Chats",
  "In: {{value}}": "In: {{value}}",
  "Leave Channel": "Leave Channel",
  "Leave Conversation": "Leave Conversation",
  "Let people know what {{name}} is focused on right now (ex. a project milestone). Descriptions are always visible in the header.": "Let people know what {{name}} is focused on right now (ex. a project milestone). Descriptions are always visible in the header.",
  "Let's start a conversation": "Let's start a conversation",
  "Looks like it’s just you two! Say hello and get the conversation rolling!": "Looks like it’s just you two! Say hello and get the conversation rolling!",
  "Max file size: 10MB": "Max file size: 10MB",
  "Max files allowed: 10": "Max files allowed: 10",
  "Members": "Members",
  "Message #{{name}}...": "Message #{{name}}...",
  "Message deleted successfully": "Message deleted successfully",
  "Message {{name}}...": "Message {{name}}...",
  "More": "More",
  "Mute notifications for active or open conversations": "Mute notifications for active or open conversations",
  "Mute:": "Mute:",
  "My Status": "My Status",
  "Name": "Name",
  "Name:": "Name:",
  "New": "New",
  "New Message": "New Message",
  "New Message.": "New Message.",
  "Next": "Next",
  "No Show checkbox": "No Show checkbox",
  "No members found": "No members found",
  "No results found for \"{{keyword}}\". Try removing filters to broaden your search.": "No results found for \"{{keyword}}\". Try removing filters to broaden your search.",
  "No users found": "No users found",
  "No users found with the given name": "No users found with the given name",
  "Notify even when team chat is open": "Notify even when team chat is open",
  "Open Link": "Open Link",
  "Out sick": "Out sick",
  "Parent message has been deleted": "Parent message has been deleted",
  "Please provide a valid channel name": "Please provide a valid channel name",
  "Please select a conversation": "Please select a conversation",
  "Reload": "Reload",
  "Reload Team Chat": "Reload Team Chat",
  "Remove": "Remove",
  "Remove Member": "Remove Member",
  "Reply in Thread": "Reply in Thread",
  "Reply to a message to create your first one and easily track it here.": "Reply to a message to create your first one and easily track it here.",
  "Retry": "Retry",
  "Save": "Save",
  "Search": "Search",
  "Search any messages or keywords": "Search any messages or keywords",
  "Search for your co-workers by typing their name": "Search for your co-workers by typing their name",
  "Search members": "Search members",
  "Send Direct Message": "Send Direct Message",
  "Set your status": "Set your status",
  "Show conversation in Channels section": "Show conversation in Channels section",
  "Show conversation in Direct Message section": "Show conversation in Direct Message section",
  "Stay on top of conversations with threads.": "Stay on top of conversations with threads.",
  "Step 1 of 2": "Step 1 of 2",
  "Step 2 of 2": "Step 2 of 2",
  "Successfully updated notification settings.": "Successfully updated notification settings.",
  "Team Chat": "Team Chat",
  "Team Chat Settings": "Team Chat Settings",
  "There was an error loading this image.": "There was an error loading this image.",
  "This channel is all set and ready for discussion! Kick things off by starting a conversation!": "This channel is all set and ready for discussion! Kick things off by starting a conversation!",
  "This group is ready for discussion. Begin by sharing your thoughts!": "This group is ready for discussion. Begin by sharing your thoughts!",
  "This hides the conversation from all your devices (Desktop and Mobile), but you can always find it again. \n The conversation will reappear automatically on the next message, or you can find it anytime by searching for it via": "This hides the conversation from all your devices (Desktop and Mobile), but you can always find it again. \n The conversation will reappear automatically on the next message, or you can find it anytime by searching for it via",
  "This link will take you to an external website. If you trust this link, tap on Open Link to continue.": "This link will take you to an external website. If you trust this link, tap on Open Link to continue.",
  "This message was deleted": "This message was deleted",
  "Thread": "Thread",
  "Thread parent message not found": "Thread parent message not found",
  "Threads": "Threads",
  "To:": "To:",
  "Topic:": "Topic:",
  "Unable to hide conversation at the moment": "Unable to hide conversation at the moment",
  "Unable to set status at the moment, please try again later": "Unable to set status at the moment, please try again later",
  "Unarchive Channel for everyone": "Unarchive Channel for everyone",
  "Update Status": "Update Status",
  "Upload Image": "Upload Image",
  "Use @ to mention others...": "Use @ to mention others...",
  "Vacationing": "Vacationing",
  "View Replies": "View Replies",
  "View Reply": "View Reply",
  "We had a problem getting mentions": "We had a problem getting mentions",
  "What's your status?": "What's your status?",
  "You": "You",
  "You can only attach up to 10 images at a time. {{count}} images were ignored._one": "You can only attach up to 10 images at a time. {{count}} images were ignored.",
  "You can only attach up to 10 images at a time. {{count}} images were ignored._other": "You can only attach up to 10 images at a time. {{count}} images were ignored.",
  "You can only upload images that are less than 10 MB in size. 1 image was not uploaded.": "You can only upload images that are less than 10 MB in size. 1 image was not uploaded.",
  "You can only upload images that are less than 10 MB in size. {{count}} images were not uploaded._one": "You can only upload images that are less than 10 MB in size. {{count}} images were not uploaded.",
  "You can only upload images that are less than 10 MB in size. {{count}} images were not uploaded._other": "You can only upload images that are less than 10 MB in size. {{count}} images were not uploaded.",
  "You’re leaving Weave App": "You’re leaving Weave App",
  "cancel": "cancel",
  "channel-search": "channel-search",
  "edited": "edited",
  "in: All Chats": "in: All Chats",
  "{{count}} Channels_one": "{{count}} Channel",
  "{{count}} Channels_other": "{{count}} Channels",
  "{{count}} DMs_one": "{{count}} DM",
  "{{count}} DMs_other": "{{count}} DMs",
  "{{count}} Replies_one": "{{count}} Reply",
  "{{count}} Replies_other": "{{count}} Replies",
  "{{count}} Reply_one": "{{count}} Reply",
  "{{count}} Reply_other": "{{count}} Reply",
  "{{count}} replies_one": "{{count}} reply",
  "{{count}} replies_other": "{{count}} replies",
  "{{createdBy}} on {{createdAt}}": "{{createdBy}} on {{createdAt}}",
  "{{senderName}} replied in {{channelName}}": "{{senderName}} replied in {{channelName}}",
  "{{total}}/{{totalCount}} characters": "{{total}}/{{totalCount}} characters"
}
